
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/store/[storeSlug]/search",
      function () {
        return require("private-next-pages/store/[storeSlug]/search.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/store/[storeSlug]/search"])
      });
    }
  